import React, { Suspense, lazy, useState, useEffect, useRef } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { userState, userInfoLoadedState } from "../../../../recoil/auth";
import {
  dashboardDataState,
  dashboardEnteredState,
  dashboardLoadingState,
} from "../../../../recoil/home/tabs/dashboard/dashboardState";
import { getMemberAdAPI } from "../../../../api";
import DashboardSummary from "./components/DashboardSummary";
import Announcements from "./components/Announcements";
import ChargeStatus from "./components/ChargeStatus";
import "./DashboardMobile.css";
import "./Dashboard.css";
import MyAdsMobile from "./components/MyAdsMobile";

const RankCheck = lazy(() => import("./components/RankCheck"));

const DashboardMobile = ({ onTabChange }) => {
  const [isPrerendering, setIsPrerendering] = useState(false);
  const user = useRecoilValue(userState);
  const userInfoLoaded = useRecoilValue(userInfoLoadedState);
  const [dashboardEntered, setDashboardEntered] = useRecoilState(
    dashboardEnteredState
  );
  const [, setDashboardData] = useRecoilState(dashboardDataState);
  const [, setLoading] = useRecoilState(dashboardLoadingState);
  const isDataLoading = useRef(false);

  // Dashboard 진입 시 데이터 로딩 (사용자 정보가 완전히 로드된 후에만 실행)
  useEffect(() => {
    const loadDashboardData = async () => {
      // 이미 로딩 중이거나 이미 진입했으면 실행하지 않음
      if (isDataLoading.current || dashboardEntered || !user?.id) {
        return;
      }

      // 사용자 정보가 완전히 로드되지 않았으면 대기
      if (!user.price_grade) {
        return;
      }

      // 사용자 정보 로딩 완료 상태 확인
      if (!userInfoLoaded) {
        return;
      }

      isDataLoading.current = true;
      setDashboardEntered(true);
      setLoading(true);

      try {
        const response = await getMemberAdAPI(user.id, 1, 10, {
          status: "APPROVED",
        });

        setDashboardData({
          ads: response.data?.data || [],
          pagination: response.data?.pagination || null,
          loading: false,
          error: null,
          lastFetched: new Date().toISOString(),
        });
      } catch (error) {
        console.error("DashboardMobile: 광고 데이터 로딩 실패", error);
        setDashboardData({
          ads: [],
          loading: false,
          error: error.message,
          lastFetched: null,
        });
      } finally {
        setLoading(false);
        isDataLoading.current = false;
      }
    };

    loadDashboardData();
  }, [
    dashboardEntered,
    user?.id,
    userInfoLoaded,
    setDashboardEntered,
    setDashboardData,
    setLoading,
  ]);

  useEffect(() => {
    // react-snap sets a specific user agent
    if (navigator.userAgent.includes("ReactSnap")) {
      setIsPrerendering(true);
    }
  }, []);

  return (
    <div className="dashboard-mobile-container">
      <div className="dashboard-mobile-section">
        <DashboardSummary />
      </div>

      <div className="dashboard-mobile-section">
        <MyAdsMobile />
      </div>

      <div className="dashboard-mobile-section">
        <Suspense
          fallback={
            <div className="dashboard-mobile-card" style={{ padding: "16px" }}>
              Loading chart...
            </div>
          }
        >
          <RankCheck />
        </Suspense>
      </div>

      <div className="dashboard-mobile-section">
        <Announcements />
      </div>

      <div className="dashboard-mobile-section">
        <ChargeStatus onTabChange={onTabChange} />
      </div>
    </div>
  );
};

export default DashboardMobile;
